import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

/**
 * Guard del link de pago.
 *
 * Flujos soportados:
 *
 * 1. Link normal:
 *    /:linkId
 *    /?identifier=:linkId
 *
 * 2. Pago directo de procesador:
 *    /?paymentMethod=BANK&identifier=:webReference
 */
export const paymentLinkGuard: CanActivateFn = (route) => {

  const router = inject(Router);

  const linkId =
    route.paramMap.get('linkId') ||
    route.queryParamMap.get('identifier');

  if (!linkId) {
    return false;
  }

  const paymentMethod =
    route.queryParamMap.get('paymentMethod');

  if (paymentMethod === 'BANK') {
    return router.createUrlTree(
      ['/processor-payment'],
      {
        queryParams: {
          identifier: linkId
        }
      }
    );
  }

  return true;
};